// A refusal the Assistant's API answered (agent_disabled, session_terminal,
// agent_daily_budget_exhausted), in words with its Help topic; any other error is the shared
// error banner, with Retry where the caller offers one, and without its request id: a request id
// is a uuid, and the Assistant never shows one (AS-1).
import type { ApiError } from "../../api/errors";
import { HelpButton } from "../../primitives/help";
import { ErrorBanner } from "../../primitives/states";
import { refusalFrom } from "./model";

export function AssistantError({ error, onRetry }: { error: ApiError; onRetry?: (() => void) | undefined }) {
  const refusal = refusalFrom(error);
  if (!refusal) return <ErrorBanner error={error} details={false} requestId={false} {...(onRetry ? { onRetry } : {})} />;
  return (
    <div class="banner banner-warning assistant-refusal" role="alert" data-refusal={refusal.code}>
      <p>
        <strong>{refusal.title}</strong> {refusal.text}
      </p>
      <HelpButton topic={refusal.help} label={refusal.title} />
    </div>
  );
}
